import { Injectable } from '@angular/core';
import { RestService } from '../rest.service';
import { URL_API } from 'src/app/tools/URL';

@Injectable({
  providedIn: 'root'
})
export class ProtocoloService {

  constructor(private rest: RestService) {}

  buscarStatusPorTipoManifestoIdManifesto(tipoManifesto, idManifesto) {

    return this.rest.get(`${URL_API.PATH_PROTOCOLO}/status`, {
        tipoManifesto,
        idManifesto
    });

  }

}
